<template>
   <div>
      <a
         id="iubenda_privacy_policy_link_it"
         href="https://www.iubenda.com/privacy-policy/8170732/cookie-policy"
         class="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed iubenda-noiframe hidden "
         title="Privacy Policy"
      >
         Privacy Policy
      </a>
      <a
         id="iubenda_privacy_policy_link_en"
         href="https://www.iubenda.com/privacy-policy/8170733/cookie-policy"
         class="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed iubenda-noiframe hidden "
         title="Privacy Policy"
      >
         Privacy Policy
      </a>
      <a
         id="iubenda_privacy_policy_link_es"
         href="https://www.iubenda.com/privacy-policy/14548218/cookie-policy"
         class="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed iubenda-noiframe hidden "
         title="Privacy Policy"
      >
         Privacy Policy
      </a>
      <v-form ref="create_associate" v-model="valid_associate_create">

         <div class="max-w-[550px] mx-auto my-2">
            <registration-title title="Crea il tuo account">
            </registration-title>

            <div class="mt-1 mb-2">
               <b>{{ $t('per_iscriversi') }}</b>
               <div>
                  <div>&#183; {{ $t('maggiorenne') }}</div>
                  <div>&#183; {{ $t('cittadinanza_valida') }}</div>
                  <div>&#183; {{ $t('possesso_cf') }}</div>
               </div>
            </div>

            <div>
               <v-text-field
                  :rules="disable_rules ? [] : [validation_rules.required]"
                  :label="$t('Nome')"
                  outlined
                  dense
                  v-model="create.nome"
               ></v-text-field>

               <v-text-field
                  :rules="disable_rules ? [] : [validation_rules.required]"
                  :label="$t('Cognome')"
                  outlined
                  dense
                  v-model="create.cognome"
               ></v-text-field>

               <div v-if="create" class="">
                  <v-menu
                     v-model="menu1"
                     :close-on-content-click="false"
                     max-width="290"
                  >
                     <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                           :label="$t('Data nascita')"
                           outlined
                           dense
                           clearable
                           :rules="
                              disable_rules ? [] : [validation_rules.required]
                           "
                           :value="computedDateFormattedMomentjs"
                           readonly
                           v-bind="attrs"
                           v-on="on"
                           @click:clear="create.data_nascita = null"
                        ></v-text-field>
                     </template>
                     <v-date-picker
                        :max="adult_age_date"
                        :show-current="adult_age_date"
                        v-model="create.data_nascita"
                        @change="menu1 = false"
                        :locale="$i18n.locale"
                     ></v-date-picker>
                  </v-menu>
               </div>

               <v-text-field
                  :rules="
                     disable_rules
                        ? []
                        : [
                             validation_rules.required,
                             validation_rules.email,
                             validation_rules.found(error_email),
                          ]
                  "
                  :label="$t('E-mail')"
                  outlined
                  dense
                  v-model="create.email"
               ></v-text-field>

               <div class="relative mb-[2.5rem] mt-[.5rem]">
                  <v-text-field
                     class="v-text-field--absolute-no-click-hidden"
                     :rules="
                        disable_rules
                           ? []
                           : [
                                validation_rules.required,
                                validation_rules.found(error_phone),
                             ]
                     "
                     hide-details="auto"
                     v-model="create.cellulare"
                  ></v-text-field>
                  <small class="vue-tel-input--label">{{
                     $t("Telefono")
                  }}</small>
                  <vue-tel-input
                     v-model="create.cellulare"
                     v-bind="bindProps"
                     @input="validationPhone1"
                     @change="validationPhone1"
                     :inputOptions="{
                        placeholder: $t('Inserisci il numero di telefono'),
                     }"
                     class="vue-tel-input"
                     :class="{
                        'vue-tel-input__valid': validation_phone.valid == true,
                        'vue-tel-input__invalid':
                           validation_phone.valid == false,
                     }"
                  ></vue-tel-input>
               </div>

               <div>
                  <v-text-field
                     :rules="
                        disable_rules
                           ? []
                           : [
                                validation_rules.required,
                                validation_rules.password,
                                validation_rules.password_match(
                                   create.password,
                                   create.r_password
                                ),
                             ]
                     "
                     :label="$t('Password')"
                     :type="mostra_pass ? '' : 'password'"
                     outlined
                     dense
                     v-model="create.password"
                  >
                     <template v-slot:append>
                        <a
                           class="-translate-y-[2px]"
                           @click="mostra_pass = !mostra_pass"
                        >
                           <v-icon v-if="mostra_pass"
                              >mdi-eye-off-outline</v-icon
                           >
                           <v-icon v-else>mdi-eye-outline</v-icon>
                        </a>
                     </template>
                  </v-text-field>
                  <v-text-field
                     :rules="
                        disable_rules
                           ? []
                           : [
                                validation_rules.password_match(
                                   create.password,
                                   create.r_password
                                ),
                             ]
                     "
                     :label="$t('Ripeti password')"
                     :type="mostra_pass ? '' : 'password'"
                     outlined
                     dense
                     v-model="create.r_password"
                  >
                     <template v-slot:append>
                        <a
                           class="-translate-y-[2px]"
                           @click="mostra_pass = !mostra_pass"
                        >
                           <v-icon v-if="mostra_pass"
                              >mdi-eye-off-outline</v-icon
                           >
                           <v-icon v-else>mdi-eye-outline</v-icon>
                        </a>
                     </template>
                  </v-text-field>
                  <div class="text-red"></div>
               </div>
               <div class="flex flex-col gap-[.5rem] mb-2">
                  <div class="flex">
                     <flip-check
                        outlined
                        :check="pricacy"
                        label=""
                        :disable_text_color="true"
                        @changeCheck="pricacy = !pricacy"
                        scale=".5"
                     ></flip-check>
                     <small class="mt-[2px]">
                        {{ $t("Ho letto e accettato i") }}
                        <a class="text-primary" @click="dialog_termini = true">
                           {{ $t("Termini e Condizioni") }}
                        </a>

                        {{ $t("e") }}
                        <!-- al clicl della label trigger il click di iubenda_privacy_policy_link -->
                        <label
                           class="text-primary cursor-pointer"
                           @click="triggerIubendaClick"
                           >{{ $t("Privacy") }}</label
                        >
                        <!-- <a class='text-primary' href='#'>Privacy Policy</a> -->
                        *
                     </small>
                  </div>

                  <div class="flex">
                     <flip-check
                        outlined
                        :check="pricacy_2"
                        label=""
                        :disable_text_color="true"
                        @changeCheck="pricacy_2 = !pricacy_2"
                        scale=".5"
                     ></flip-check>
                     <small class="mt-[2px]">
                        {{ $t("auth_trasmissione_miei_dati") }}
                        <a
                           class="text-primary"
                           @click="dialog_termini = true"
                           >{{ $t("Termini e Condizioni") }}</a
                        >
                        *
                     </small>
                  </div>

                  <div class="flex">
                     <flip-check
                        outlined
                        :check="newsletter"
                        label=""
                        :disable_text_color="true"
                        @changeCheck="newsletter = !newsletter"
                        scale=".5"
                     ></flip-check>
                     <small class="mt-[2px]">{{ $t("auth_newsletter") }}</small>
                  </div>
               </div>

               <div class="grid grid-cols-1 gap-[.5rem] divide-y divide-grey">
                  <div class="pb-[1rem]">
                     <v-btn
                        :color="!pricacy || !pricacy_2 ? 'grey' : 'primary'"
                        :class="{
                           'pointer-events-none': !pricacy || !pricacy_2,
                        }"
                        :loading="isLoading"
                        dark
                        block
                        @click="creaAccount()"
                        >{{ $t("Registrati") }}</v-btn
                     >
                  </div>
                  <div class="flex justify-start pt-[.5rem]">
                    <small><a class="block text-center" @click="routerTarget">{{$t('Torna al login')}}</a></small>
                  </div>
               </div>

               <v-progress-linear
                  v-if="isLoading"
                  color="primary"
                  indeterminate
               ></v-progress-linear>
            </div>
         </div>
      </v-form>

      <div class="mt-2">
         <v-alert type="error" @click="handleError" v-if="error">{{
            error
         }}</v-alert>
      </div>

      <v-dialog
         class="dialog-termini-e-condizioni"
         v-model="dialog_termini"
         width="950"
      >
         <v-card>
            <v-card-title class="text-h5 grey mb-3 lighten-2">
               {{ $t("titolo termini e condizioni") }}
            </v-card-title>

            <v-card-text>
               <div class="termini_e_condizioni" >
                  <p data-renderer-start-pos="1" v-html="termini"></p>
                  <p class="mt-3 text-right">{{ $t('data termini e condizioni') }}</p>
               </div>
            </v-card-text>
         </v-card>
      </v-dialog>
   </div>
</template>

<script>
import _termini from "./termini&condizioni/terminiCondizioni.json"
import moment from "moment";
export default {
   name: "TheRegistration",
   data() {
      return {
         dialog_termini: false,
         mostra_pass: false,
         error: null,

         create: {
            nome: "",
            cognome: "",
            email: "",
            cellulare: "",
            password: "",
            data_nascita: "",
            r_password: "",
         },

         disable_rules: true,

         isLoading: false,

         termini_data: {
            it: "8 settembre 2023",
            en: "September 8, 2023",
            es: "8 de septiembre de 2023",
         },

         pricacy: false,
         pricacy_2: false,
         newsletter: false,

         error_email: false,
         error_phone: false,

         menu1: false,
         validation_phone: {},
         valid_associate_create: true,
      };
   },
   watch: {
      "create.password"() {
         this.disable_rules = true;
      },
      "create.r_password"() {
         this.disable_rules = true;
      },
      "create.email"() {
         this.error_email = false;
      },
   },
   computed: {
      termini() {
         return _termini[this.$i18n.locale];
      },
      computedDateFormattedMomentjs() {
         if (this.create && this.create.data_nascita)
            return this.create.data_nascita
               ? moment(this.create.data_nascita).format("DD/MM/YYYY")
               : "";

         return null;
      },
   },
   methods: {
        routerTarget(){
            let main_path = this.$route.meta.from == 'agency' ? '' : '-models'
            this.$router.replace({ path: `/login${main_path}` });
        },
      handleError() {
         this.error = null;
      },
      triggerIubendaClick() {
         console.log("this.$i18n.locale",this.$i18n.locale);

         switch(this.$i18n.locale){
            case "it":
               document.getElementById("iubenda_privacy_policy_link_it").click();
               break;
            case "en":
               document.getElementById("iubenda_privacy_policy_link_en").click();
               break;
            case "es":
               document.getElementById("iubenda_privacy_policy_link_es").click();
               break;
         }
      },
      validationPhone1(formattedNumber, { number, valid, country }) {
         if (this.create && this.validation_phone) {
            this.validation_phone.formattedNumber = formattedNumber;
            this.validation_phone.number = number;
            this.validation_phone.valid = valid;
            this.validation_phone.country = country && country.name;
            if (this.create.cellulare.charAt(0) != "+") {
               this.create.cellulare = number;
            }
         }
         this.error_phone = false;
      },
      async creaAccount() {
         this.disable_rules = false;
         await this.delay(200);
         let valid = await this.$refs.create_associate.validate();
         if (valid) {
            this.isLoading = true;

            let body_create_account = {
               type: "registration",
               nome: this.create.nome,
               cognome: this.create.cognome,
               email: this.create.email,
               password: this.create.password,
               conferma_email: "",
               timestamp: Math.floor(new Date().getTime() / 1000),
               cellulare: this.create.cellulare.replaceAll(" ", ""),
               fromsite: this.$route.meta.from,
               useragent: navigator.userAgent,

               dataNascita: this.formatDate(
                  this.create.data_nascita,
                  "DD/MM/YYYY"
               ),

               terminiCondizioni: 1,
               privacy: 1,
               newsletter: this.newsletter,
            };
            console.log(body_create_account);
            let _response = await this.$store.dispatch(
               "createAccount",
               body_create_account
            );
            if (_response && _response.error) {
               this.isLoading = false;

               this.error_email =
                  _response.code == "unique_email" ? true : false;
               this.error_phone = _response.message.includes(
                  "EXISTING_CELLULARE"
               )
                  ? true
                  : false;

               console.log("ERROR", _response.message);
               return;
            }

            const redirectUrl = this.$route.query.target ?? "/account/data";
            this.$router.replace(redirectUrl);
            this.isLoading = false;
         }
      },
   },
   mounted() {
        const script = document.createElement('script');
        script.src = 'https://cdn.iubenda.com/iubenda.js';
        const tag = document.getElementsByTagName('script')[0];
        tag.parentNode.insertBefore(script, tag);

        console.log("navigator.userAgent",navigator);
    }
};
</script>

<style lang="scss" scope>
/*  */
</style>